export const AydinlatmaMetni = () => {
  return (
    <div className="container mx-auto px-4 py-16 mt-16">
      <div className="max-w-4xl mx-auto prose prose-lg">
        <h1 className="text-3xl font-bold mb-8">AYDINLATMA METNİ</h1>

        <p className="mb-6">
          www.kampusmentorluk.com (Bundan böyle "Web Sitesi" olarak anılacaktır) olarak, 6698 Sayılı Kişisel Verilerin Korunması Kanunu'nun ("Kanun") 10uncu maddesi uyarınca hazırladığımız ve Web Sitesi'nin kişisel veri işleme faaliyetleri hakkında bilgi içeren aydınlatma metnini kamuoyunun ve ilgili kişilerin bilgilerine sunarız;
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">MADDE 1: VERİ SORUMLUSU</h2>
        <p className="mb-6">
          Kişisel verileriniz, veri sorumlusu sıfatıyla Web Sitesi tarafından aşağıda açıklanan kapsamda işlenebilecektir. Veri sorumlusu kavramından anlaşılması gereken; kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin kurulmasında ve yönetilmesinden sorumlu gerçek veya tüzel kişidir. Veri sorumlusuyla irtibata geçmek için aşağıdaki kanalları kullanabilirsiniz:
        </p>
        <p className="mb-6">
          E-posta: info@kampusmentorluk.com<br />
          İnternet sitesi: www.kampusmentorluk.com
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">MADDE 2: KİŞİSEL VERİLERİ İŞLEME AMACI</h2>
        <p className="mb-4">Kişisel veriler tarafımızca aşağıdaki amaçlarla işlenmektedir:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Mentörlük hizmetlerinin sağlanması ve yönetimi</li>
          <li>Öğrenci-mentör eşleştirmelerinin yapılması</li>
          <li>Eğitim planlaması ve takibi</li>
          <li>İnsan kaynakları süreçlerini yürütmek</li>
          <li>Kurumsal iletişimi sağlamak</li>
          <li>Web Sitesi güvenliğini sağlamak</li>
          <li>İstatistiksel çalışmalar yapabilmek</li>
          <li>İmzalanan sözleşmeler ve protokoller neticesinde iş ve işlemleri ifa edebilmek</li>
          <li>Yasal düzenlemelerin gerektirdiği veya zorunlu kıldığı şekilde, hukuki yükümlülüklerin yerine getirilmesini sağlamak</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">MADDE 3: KİŞİSEL VERİLERİN AKTARILABİLECEĞİ TARAFLAR VE AKTARMA AMACI</h2>
        <p className="mb-6">
          Müşterilere ilişkin kişisel veriler, Kanun'un 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde, Web Sitesi tarafından sunulan mentörlük hizmetlerinin ilgili kişilerin ihtiyaçlarına göre özelleştirilmesi, mentörlük hizmetlerinin planlanması ve yürütülmesi, yasal yükümlülüklerin yerine getirilmesi amacıyla gerekli olan hallerde iş ortakları, tedarikçiler ve hukuken yetkili kurum ve kuruluşlar ile paylaşılabilecektir.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">MADDE 4: KİŞİSEL VERİ TOPLAMA YÖNTEMLERİ VE HUKUKİ SEBEPLERİ</h2>
        <p className="mb-4">Kişisel veriler aşağıdaki yöntemler ve hukuki sebepler ile toplanmaktadır:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Web sitesi üzerinden doldurulan formlar</li>
          <li>Mentörlük hizmet sözleşmelerinin kurulması ve ifası</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
          <li>Meşru menfaatlerin korunması</li>
          <li>İlgili kişilerin açık rızası</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">MADDE 5: İLGİLİ KİŞİNİN HAKLARI</h2>
        <p className="mb-4">Kişisel verisi işlenen gerçek kişi, ilgili kişi olarak tanımlanır ve Web Sitesi'ne başvurarak kendisiyle ilgili aşağıdaki haklara sahiptir:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
          <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme</li>
          <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
          <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
          <li>Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
          <li>Kişisel verilerin silinmesini veya yok edilmesini isteme</li>
          <li>Yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
          <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
          <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
        </ul>

        <p className="mt-8">Saygılarımızla;</p>
        <p className="font-semibold">Kampüs Mentörlük</p>
      </div>
    </div>
  );
}; 